import { render, staticRenderFns } from "./Prime.vue?vue&type=template&id=eb55c040&scoped=true&"
import script from "./Prime.vue?vue&type=script&lang=js&"
export * from "./Prime.vue?vue&type=script&lang=js&"
import style0 from "./Prime.vue?vue&type=style&index=0&id=eb55c040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb55c040",
  null
  
)

export default component.exports